export function lerp(value, min, max) { return (min + ((max - min) * value)); }
export function unlerp(value, min, max) { return ((value - min) / (max - min)); }
